import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { GeneralLedger } from '../components/finance/GeneralLedger';
import { Clients } from '../components/finance/Clients';
import { Suppliers } from '../components/finance/Suppliers';
import { ETAReceived } from '../components/finance/ETAReceived';

export const Finance = () => {
  const { t, language } = useLanguage();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'ledger';

  return (
    <div className="p-8" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <h1 className="text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="finance-title">
        {t('finance')}
      </h1>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="mb-6" dir={language === 'ar' ? 'rtl' : 'ltr'}>
          <TabsTrigger value="ledger" data-testid="tab-ledger">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('generalLedger')}</span>
          </TabsTrigger>
          <TabsTrigger value="clients" data-testid="tab-clients">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('clients')}</span>
          </TabsTrigger>
          <TabsTrigger value="suppliers" data-testid="tab-suppliers">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('suppliers')}</span>
          </TabsTrigger>
          <TabsTrigger value="eta-received" data-testid="tab-eta-received">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('etaReceived')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="ledger">
          <GeneralLedger />
        </TabsContent>
        <TabsContent value="clients">
          <Clients />
        </TabsContent>
        <TabsContent value="suppliers">
          <Suppliers />
        </TabsContent>
        <TabsContent value="eta-received">
          <ETAReceived />
        </TabsContent>
      </Tabs>
    </div>
  );
};